import React from 'react';
import FeatherIcon from './FeatherIcon';
import withDefaultIconProps from './withDefaultIconProps';
const SearchIcon = props => {
    return React.createElement(FeatherIcon, { name: "search", ...props });
};
export default withDefaultIconProps(SearchIcon);
